import { atom } from "recoil";

export const addStateEmailWorkFlow = atom({
  key: "addStateEmailWorkFlow",
  default: false,
});

export const selectedRowsStateEmailWorkFlow = atom({
  key: "selectedRowsStateEmailWorkFlow",
  default: 0,
});
